<form [formGroup]="formGroup">
    <app-rm-rates [type]="rateType" [index]="index" *ngIf="rate == null"></app-rm-rates>

    <div *ngIf="rate">
        <div class="container content">
            <div class="row">
                <div class="col-lg-12">
                    <h5 class="title-step" align="center">
                        <img src="./assets/img/package.svg" class="img-fluid ico-title" width="20">
                        {{ index == 0 ? 'Tarifa ' + (typeOperation === 'mobile' ? 'línea móvil principal' : 'Móvil principal') : 'Tarifa ' + (index + 1) + 'º línea móvil' }}
                    </h5>
                    <div class="card card-default card-horizontal mb-5">
                        <div class="card-heading">
                            <div class="row">
                                <div class="col-lg-6">
                                    <h5 align="left" class="tar-name car-tar-1">
                                        {{ (rateFtth !== null && index === 0) ? rateFtth.name + ' + ' : '' }} {{ rate.name }}
                                    </h5>
                                </div>
                                <div class="col-lg-6 align-self-center">
                                    <h5 align="left" class="tar-price car-tar-2">
                                        <!-- descuento para primera línea de convergente TODO: usar info del WS de a cuantas lineas aplica el desccuento -->
                                        <ng-container *ngIf="rateFtth === null || index > 0">
                                            {{ priceWithIVA(rate.rateAmount).toFixed(0) }}
                                            <span>€/mes</span>
                                        </ng-container>
                                        <ng-container *ngIf="rateFtth !== null && index === 0">
                                            {{ priceWithIVA(+rateFtth.rateAmount + +rate.rateAmount - +rateFtth.discount).toFixed(0) }}
                                            <span>€/mes</span>
                                        </ng-container>
                                    </h5>
                                </div>
                            </div>

                        </div>
                        <div class="card-body">
                            <div class="row" *ngIf="rateFtth && index === 0">
                                <div class="col-md-5 d-flex flex-column justify-content-center mb-3 mb-md-0">
                                    <h5 align="left" class="tar-name-5 my-0" *ngIf="rateFtth.resumeLabelData">
                                        <b>{{ rateFtth.resumeLabelData }}</b>
                                    </h5>
                                    <h5 align="left" class="tar-name-5 my-0">
                                        <b>INSTALACIÓN GRATIS</b>
                                    </h5>
                                    <h5 align="left" class="tar-name-5 my-0">
                                        <b>ROUTER EN CESIÓN GRATIS</b>
                                    </h5>
                                </div>
                                <div class="col-md-auto"><span class="vl mobile"></span></div>
                                <div class="col-md-5 d-flex flex-column justify-content-center mb-3 mb-md-0">
                                    <h5 align="left" class="tar-name-5 my-0" *ngIf="rate.labelData || rate.sublabelData">
                                        {{ rate?.labelData }} <b>{{ rate?.sublabelData }}</b>
                                    </h5>
                                    <h5 align="left" class="tar-name-5 my-0" *ngIf="rate.resumeLabelVoice">
                                        {{ rate.resumeLabelVoice }}
                                    </h5>
                                </div>
                                <div class="col-md-1 btn-change d-flex align-items-center justify-content-center justify-content-md-start">
                                    <a class="btn btn-green btn-sm" (click)="changeRate()">Cambiar</a>
                                </div>
                            </div>


                            <div class="row" *ngIf="!rateFtth || index !== 0">
                                <div class="col-md-5 d-flex align-items-center">
                                    <h5 align="left" class="tar-name-5 my-0" *ngIf="rate.labelData">
                                        <b>{{ rate.labelData }}</b> de navegación
                                    </h5>
                                    <h5 align="left" class="tar-name-5 my-0" *ngIf="rate.resumeLabelData">
                                        <b>{{ rate.resumeLabelData }}</b>
                                    </h5>
                                </div>
                                <div class="col-md-auto"><span class="vl mobile"></span></div>
                                <div class="col-md-5 d-flex align-items-center">
                                    <h5 align="left" class="tar-name-5 my-0" *ngIf="rate.resumeLabelVoice">
                                        <b>{{ rate.resumeLabelVoice }}</b>
                                    </h5>
                                </div>
                                <div class="col-md-1 btn-change align-self-center">
                                    <a class="btn btn-green btn-sm" (click)="changeRate()">Cambiar</a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container content">
            <div class="row">
                <div class="col-lg-12">
                    <h5 class="title-step" align="center">
                        <img src="./assets/img/smartphone.svg" class="img-fluid ico-title" width="20"> Tipo de operación línea móvil
                    </h5>
                    <div class="card">
                        <div class="card-header">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <!----- Tipo de operación ------->
                                    <div class="radio-btn-group" ngbRadioGroup
                                         formControlName="type_operation"
                                         (change)="changeTypeOperation($event.target.value)">
                                        <h6 class="subtitulo-pack">Tipo de operación: </h6>

                                        <div class="radio radio-pack">
                                            <label ngbButtonLabel>
                                                <input ngbButton type="radio" value="registration"/>
                                                Alta nueva
                                            </label>
                                        </div>

                                        <div class="radio radio-pack">
                                            <label ngbButtonLabel>
                                                <input ngbButton type="radio" value="portability"/>
                                                Portabilidad
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <small class="text-muted">
                                    <!----- Fecha estimada si es portabilidad / si es alta no aparece nada------->
                                    <!--<h6 class="subtitulo-pack fecha">Fecha estimada de portabilidad: <span class="verde"><b>04/04</b></span></h6>-->
                                </small>
                            </div>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item cuerpo-pack">
                                <h6 class="subtitulo-pack-form" *ngIf="typeOperation === 'portability'">Datos de alta / portabilidad</h6>

                                <div class="form-row" *ngIf="typeOperation === 'portability'">
                                    <div class="col-lg-3 mb-0 mt-1">
                                        <mat-form-field>
                                            <mat-label>Teléfono móvil a portar</mat-label>
                                            <input type="text" matInput formControlName="portability_phone" maxlength="9">
                                        </mat-form-field>
                                        <mat-error *ngIf="formGroup.get('portability_phone')?.errors?.notmustMatch">
                                            Número de teléfono a portar ya utilizado en este flujo
                                        </mat-error>
                                    </div>
                                    <div class="col-lg-2 mt-1">
                                        <mat-form-field>
                                            <mat-label>Operador donante</mat-label>

                                            <select matNativeControl formControlName="portability_operator">
                                                <option *ngFor="let provider of serviceProviders" [value]="provider.service_provider_id">{{ provider.name }}</option>
                                            </select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-lg-3 mt-1">
                                        <mat-form-field>
                                            <mat-label>Tipo de cliente donante</mat-label>
                                            <select matNativeControl formControlName="portability_type_client"
                                                    (change)="changePortabilityTypeClient($event.target.value)">
                                                <option [value]="'postpaid'" [selected]="portabilityTypeClient === 'postpaid'">Contrato</option>
                                                <option [value]="'prepaid'" [selected]="portabilityTypeClient === 'prepaid'">Prepago</option>
                                            </select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-lg-4 mt-1" *ngIf="portabilityTypeClient === 'prepaid'">
                                        <mat-form-field class="col-11">
                                            <mat-label>ICCID donante</mat-label>
                                            <input type="text" matInput formControlName="portability_iccid" maxlength="19" minlength="19">
                                            <mat-hint align="end">{{ formGroup.get('portability_iccid').value.length }} / 19</mat-hint>
                                        </mat-form-field>
                                        <a class="cursor-pointer" (click)="openModalICCID(ICCID)" title="¿Dónde encuentro el ICCID?">
                                            <img src="./assets/img/info.svg" class="img-fluid ico-title icon-white" width="20">
                                        </a>
                                        <mat-error *ngIf="formGroup.get('portability_iccid')?.errors?.notmustMatch">
                                            ICCID ya utilizado en este flujo
                                        </mat-error>
                                    </div>
                                    <div class="col-lg-4 mt-1">
                                        <mat-form-field>
                                            <mat-label>Fecha de portabilidad</mat-label>
                                            <input type="text" matInput formControlName="portability_date" [matDatepicker]="picker" [matDatepickerFilter]="withoutWeekendFilter"
                                                   [min]="minDate" [max]="maxDate">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <h6 class="subtitulo-pack-form">Datos SIM en República Móvil</h6>

                                <div class="form-row">
                                    <div class="col-lg-5 mb-0">
                                        <mat-form-field class="col-11">
                                            <mat-label>ICCID entregado al cliente</mat-label>
                                            <input type="text" matInput formControlName="iccid" maxlength="19" minlength="19" (focus)="addPrefix()">
                                            <mat-hint align="end">{{ formGroup.get('iccid').value.length }} / 19</mat-hint>
                                        </mat-form-field>
                                        <a class="cursor-pointer" (click)="openModalICCID(ICCID)" title="¿Dónde encuentro el ICCID?">
                                            <img src="./assets/img/info.svg" class="img-fluid ico-title icon-white" width="20">
                                        </a>
                                        <mat-error *ngIf="formGroup.get('iccid')?.errors?.notmustMatch">
                                            ICCID ya utilizado en este flujo
                                        </mat-error>
                                    </div>
                                </div>

                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- bloque línea adicional -->
            <div class="jumbotron-ad mt-3" *ngIf="allowAddAdditionalLines">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <span class="ad-text">¿Deseas añadir <b>una línea de móvil adicional</b>?</span>
                    </div>
                    <small class="text-muted btn-muted">
                        <a (click)="addMobileLine()" class="btn btn-black2 btn-sm" role="button">Contratar <span class="mobile">línea de móvil adicional</span></a>
                    </small>
                </div>
            </div>


            <!-- Continuar proceso -->
            <div align="center">
                <br>
                <a (click)="next()" class="btn btn-black btn-block mb-1" role="button">
                    Continuar <img src="./assets/img/arrow-right-white.svg" class="img-fluid ico-title" width="15">
                </a>
                <a (click)="prev()" class="btn btn-grey2 btn-block mb-5" role="button" *ngIf="!(typeOrder === 'mobile' && index === 0)">Volver</a>
                <br><br>
            </div>
        </div>
    </div>
</form>

<ng-template #ICCID let-modal>
    <div class="modal-header">
        <h5 class="modal-title white" id="exampleModalLabel">¿Dónde encuentro el ICCID?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">
                <img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20">
            </span>
        </button>
    </div>
    <img src="./assets/img/iccid.png" class="img-fluid ico-title p-5">
</ng-template>
